import type { ID, Lot } from 'types';

const lotsByIdCache = new WeakMap<Lot[], Map<string, Lot>>();

export const findOriginalLot = (originalLots: Lot[] | undefined, lotId: ID): Lot | undefined => {
  if (!originalLots) return undefined;
  let lotsById = lotsByIdCache.get(originalLots);
  if (!lotsById) {
    lotsById = new Map(originalLots.map(lot => [String(lot.id), lot]));
    lotsByIdCache.set(originalLots, lotsById);
  }
  return lotsById.get(String(lotId));
};
